<template>
  <div>
    <el-menu :default-active="msg" class="el-menu-demo" mode="horizontal" router="true" @select="handleSelect">
<!--      <div v-for="(val,key) in nav" v-bind:key="key" style="display: inline-block;">-->
<!--        <el-menu-item :index="val.path">{{val.name}}</el-menu-item>-->
<!--      </div>-->
      <el-menu-item v-for="(val,key) in nav" v-bind:key="key" :index="val.path">{{val.name}}</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
name: "nav",
  props: {
    msg: String,
    nav:String
  },
  data() {
    return {
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key);
      console.log(keyPath);
    }
  }
}
</script>

<style scoped>

</style>